import { styled } from 'styled-components';

export const MoveIcon = styled.div`
    position: absolute;
    top: 15px;
    left: 15px; /* Start offscreen to the left */
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    z-index: 55;
    width:30px;
    height: 30px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: rgba(37, 83, 185, 0.1) 0 2px 6px !important;
`;

export const DraggedCardContainer = styled.div<{ isHovered: boolean; isDragging: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  &:hover ${MoveIcon} {
    opacity: 1;
    pointer-events: auto;
    transform: translate(0%, 0%);
  }

  background-color: ${({ isHovered }) => (isHovered ? '#e0f7fa' : 'transparent')};
  border: ${({ isHovered }) => (isHovered ? '2px dashed #007bff' : '1px solid transparent')};
  opacity: ${({ isHovered }) => (isHovered ? 0.6 : 1)};
  padding: ${({ isHovered }) => (isHovered ? '4px' : '0px')};
  
  /* iOS-style shake animation */
  ${({ isDragging }) => isDragging && `
    animation: shake 0.5s ease-in-out infinite;
    transform-origin: center center;
  `}
  
  @keyframes shake {
    0% { transform: rotate(0deg) scale(1); }
    25% { transform: rotate(-0.5deg) scale(1.005); }
    50% { transform: rotate(0.5deg) scale(1); }
    75% { transform: rotate(-0.5deg) scale(1.005); }
    100% { transform: rotate(0deg) scale(1); }
  }
`;

export const DragHandle = styled.div`
  font-size: 14px;
  cursor: grab;
  transition: background-color 0.2s ease;
  &:active {
    cursor: grabbing;
  }
`;
